import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICardModel } from '@src/app/interface/users';
import { TripsService } from '@src/app/services/user-managment/trips/trips.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-upcoming',
  templateUrl: './upcoming.component.html',
  styleUrls: ['./upcoming.component.css']
})
export class UpcomingComponent implements OnInit {

 subscription = new Subscription();
  allTrips:ICardModel[] = [];
  trips:ICardModel[] = [];
  pageSize = 5;

  constructor(public translate: TranslateService, public tripService : TripsService) { }

  ngOnInit(): void {
    if(this.tripService.allTrips.upcomingFlights.length){
      this.allTrips = this.tripService.getFlightDetails(this.tripService.allTrips.upcomingFlights);
      this.trips = this.allTrips.slice(0, this.pageSize);
    }

    this.subscription.add(
      this.tripService.notify.subscribe({
        next: (data) => {
          if(data){

          }else{
            this.allTrips = this.tripService.getFlightDetails(this.tripService.allTrips.upcomingFlights);
            this.trips = this.allTrips.slice(0, this.pageSize);
          }
        },error: (error) => {
          this.showErrorAlert(error); 
        }
    }))

    
  }

  onPaginate(currentPage: any) {
    const startIndex = (currentPage) * this.pageSize;
    const lastIndex = startIndex + this.pageSize - 1;
    this.trips = this.allTrips.slice(startIndex, lastIndex);
  }

  get lang() {
    return this.translate.currentLang;
  }

  get isLoading() {
    return this.tripService.isLoading;
  }

  private showErrorAlert(error: any) {
    Swal.fire({
      icon: 'error',
      title: this.translate.instant('Error'),
      text: this.translate.instant('An error occurred while fetching data.'),
      confirmButtonText: this.translate.instant('OK')
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


}
